<div class="container-fluid">
    <div class="d-flex flex-column flex-md-row justify-content-md-between p-1">
        <h6 class="mb-1">Liste des élèves</h6>
        <div class="d-flex flex-column flex-md-row">
           
            <select class="mx-1 mb-1" id="" (change)="loadlist1($event)">
                <option selected disabled>Choisir la classe</option>
                <option *ngFor="let c of classrooms" [value]="c.classroom?.id">{{c.classroom?.name}}</option>
            </select>
            <select class="mx-1 mb-1" id="" (change)="loadlist2($event)">
                <option selected disabled>Choisir l'année académique</option>
                <option *ngFor="let ay of ays" [value]="ay.id">{{ay.name}}</option>
            </select>

            <button (click)="add(addContent)" class="btn g-bg-danger text-white">Ajouter un document</button>
        </div>
    </div>

    <app-educational-resource-list (fileData)="getFile($event)" [data]="data"></app-educational-resource-list>
</div>


<ng-template #addContent let-c="close" let-d="dismiss">
    <form #addForm="ngForm" (ngSubmit)="store(addForm.value)">
    <div class="modal-header">
      <h6 class="modal-title" id="modal-basic-title">Ajouter un document</h6>
      <button type="button" class="btn-close" aria-label="Close" (click)="d('Cross click')"></button>
    </div>
    <div class="modal-body" >
        <div class="row mb-3" >
      
            <div class=" form-group col-12 mb-3">
                <label for="">Thème <span class="text-danger ml-2">(*)</span></label>
                <input type="text" name="theme" class="form-control" ngModel>
            </div>
            <div class=" form-group col-12 mb-3">
                <label for="">Commentaire<span class="text-danger ml-2">(*)</span></label>
                <textarea name="comment" class="form-control" ngModel maxLength="191"></textarea>
            </div>
            <div class="form-group col-12">
                <label for="">Choisir le public</label>
                <select class="mx-1 form-control" ngModel name="classroom_id">
                    <option selected disabled></option>
                    <option *ngFor="let c of classrooms" [value]="c.classroom?.id">{{c.classroom?.name}}</option>
                </select>
            </div>
            <div class=" form-group col-12 mb-3">
                <label for="">Ajouter votre document <span class="text-danger ml-2">(*)</span></label>
                <input type="file" class="form-control" (change)="upload($event)" accept=".pdf">
            </div>
        </div>
       
    </div>
    <div class="modal-footer">
      <button type="submit" class="btn btn-outline-dark" [disabled]="addForm.invalid"  >Enregistrer <app-loading [isVisible]="loading"></app-loading></button>
    </div>
</form>
  </ng-template>


  <ng-template #contentPDF let-offcanvas>
	<div class="offcanvas-header">
    
		<h4 class="offcanvas-title">Visualiseur de fichier</h4>
		<button id="closePDFBtn" type="button" class="btn-close" aria-label="Close" (click)="offcanvas.dismiss('Cross click')"></button>
	</div>
	<div class="offcanvas-body">
        <ngx-extended-pdf-viewer [src]="pdfSrc"
        style="width: 100%; height: 100%"
        ></ngx-extended-pdf-viewer>
	</div>
</ng-template>
